let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1mB2Z")).then(() => parcelRequire('cGCRX'));